












import { addThousandSeparator, isIntOrFloat, round } from '@/utils/CommonUtils'
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component
export default class InputPercentage extends Vue {
  @Prop() readonly value!: string | number
  @Prop({ type: Boolean, default: false }) readonly alignLeft!: boolean
  @Prop({ default: 1 }) readonly decimalPlaces!: number
  @Prop({ type: Boolean, default: true }) readonly hideSuffix!: boolean

  intOrFloat (val: string | number) {
    if (val === '' || val === null) return true
    val = val.toString()
    // Remove comma (thousand separator)
    val = val.replaceAll(',', '')
    return isIntOrFloat(val) || 'Xin hãy nhập số.'
  }

  get displayValue () {
    if (this.value === '' || this.value === null || isNaN(this.value as number)) {
      return ''
    }
    let returnVal = parseFloat(this.value as string) * 100
    returnVal = round(returnVal, 2)
    if (returnVal === Infinity || returnVal === -Infinity) {
      return ''
    }
    return addThousandSeparator(returnVal)
  }

  set displayValue (val) {
    // Remove comma (thousand separator)
    val = val.replaceAll(',', '')

    // Only save upto 2 decimal places
    if (val.includes('.')) {
      const decimalPlaces = val.split('.')[1].length
      if (decimalPlaces > 2) {
        let emitVal = parseFloat(val)
        emitVal = Math.floor(emitVal * 100) / 100
        emitVal = round(emitVal / 100, 4)
        this.updateValue(emitVal)
        return
      }
    }

    let returnVal
    if (val === '' || val === null || isNaN(parseFloat(val))) {
      returnVal = null
    } else {
      returnVal = parseFloat(val) / 100
    }
    if (returnVal === Infinity || returnVal === -Infinity) {
      returnVal = null
    }
    this.updateValue(returnVal)
  }

  @Emit('input')
  updateValue (value: number | string | null) {
    return value
  }
}
